import Navbar from "../components/guest/Navbar";
import Footer from "../components/guest/Footer";
import BackToTop from "../components/BackToTop";
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from "react-dom";
import { Loading } from "../components/Loading";
import { Helmet } from 'react-helmet';
import { useLocation } from "react-router-dom";

export default function GuestLayout({ children, title }){
    const { pathname, hash } = useLocation();
    let node = null;

    useEffect(() => {
        if (hash !== '#policy'){
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    useEffect(() => {
        node = ReactDOM.findDOMNode(this);
        // Get child nodes
        if (node instanceof HTMLElement) {
            const child = node.querySelector('#body');
        }
    }, [])

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 400) {
                setBackToTop(true);
            } else {
                setBackToTop(false);
            }
        });
    })

    const scrollUp = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    const [backToTop, setBackToTop] = useState(false)
    
    return (
        <>
            <Helmet>
                <title>{title ? `UResolve® | ${title}` : 'UResolve® | Easily And Risk Free Dispute Resolution'}</title>
            </Helmet>
            <Loading />
            <Navbar />
            <div className="overflow-hidden" id="body">
                {children}
            </div>
            <Footer />

            {backToTop && <BackToTop action={scrollUp}  />}
        </>
    );
}